import modular from 'stereomodularjs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';
import './utils/events';

const env = process.env.NODE_ENV

const app = new modular({
    modules: modules
});


function init() {
    window.transitionDelay = 0;

    globals();

    app.init(app);

   
}

init();